import { ModelName, RouteQueries } from './quickload.types';
import { CurrentBoardFullDocument } from './queries/CurrentBoardFullQuery.generated';
import { MemberBoardsDocument } from './queries/MemberBoardsQuery.generated';
import { MemberQuickBoardsDocument } from './queries/MemberQuickBoardsQuery.generated';
import { PreloadCardDocument } from './queries/PreloadCardQuery.generated';
import { QuickBoardsSearchDocument } from './queries/QuickBoardsSearchQuery.generated';
import { WorkspaceBoardsPageMinimalDocument } from './queries/WorkspaceBoardsPageMinimalQuery.generated';
import { MemberHeaderDocument } from './queries/MemberHeaderQuery.generated';

export const Requests: RouteQueries = {
  header: [
    {
      apiUrl: '/1/Members/:idMember',
      query: MemberHeaderDocument,
      rootId: ':idMember',
      modelName: ModelName.Member,
    },
  ],
  '^/([^/]+)/boards$': [
    {
      apiUrl: '/1/Members/:idMember',
      query: MemberBoardsDocument,
      rootId: ':idMember',
      modelName: ModelName.Member,
    },
  ],
  '^/$': [
    {
      apiUrl: '/1/Members/:idMember',
      query: MemberBoardsDocument,
      rootId: ':idMember',
      modelName: ModelName.Member,
    },
  ],
  '^/b/([^/]+)': [
    {
      apiUrl: '/1/Boards/:idBoard',
      query: CurrentBoardFullDocument,
      rootId: ':idBoard',
      modelName: ModelName.Board,
    },
  ],
  '^//([^/]*([^/]+))$': [
    {
      apiUrl: '/1/Members/:idMember',
      query: MemberQuickBoardsDocument,
      rootId: ':idMember',
      modelName: ModelName.Member,
    },
    {
      apiUrl: '/1/Search',
      query: QuickBoardsSearchDocument,
      rootId: ':searchTerm',
      appendRootIdToUrl: false,
      modelName: ModelName.Search,
    },
  ],
  '^/search': [
    {
      apiUrl: '/1/Members/:idMember',
      query: MemberQuickBoardsDocument,
      rootId: ':idMember',
      modelName: ModelName.Member,
    },
    {
      apiUrl: '/1/Search',
      query: QuickBoardsSearchDocument,
      rootId: ':searchTerm',
      appendRootIdToUrl: false,
      modelName: ModelName.Search,
    },
  ],
  '^//$': [
    {
      apiUrl: '/1/Members/:idMember',
      query: MemberQuickBoardsDocument,
      rootId: ':idMember',
      modelName: ModelName.Member,
    },
  ],
  '^/c/([^/]+)': [
    {
      apiUrl: '/1/Cards/:idCard',
      query: PreloadCardDocument,
      rootId: ':idCard',
      modelName: ModelName.Card,
    },
  ],
  '^/(?!search)(?!create-first-team)(?!blank)(?!shortcuts)(?!templates)(?!redeem)([^/]+)$': [
    {
      apiUrl: '/1/Organizations/:idOrganization',
      query: WorkspaceBoardsPageMinimalDocument,
      rootId: ':idOrganization',
      modelName: ModelName.Organization,
    },
  ],
};
